var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FlagIcon from "@mui/icons-material/Flag";
import { Box } from "@mui/material";
import { useState } from "react";
import { getIconForLanguage, getLocalizedLangLabel } from "../../utils/translations.util";
import { ElementChip } from "../uiElements/base/ElementChip";
import { normalizeLanguageCode } from "./profileLanguage.util";
export var LanguageFlag = function (_a) {
    var code = _a.code, _b = _a.size, size = _b === void 0 ? 18 : _b;
    var _c = useState(false), hasIconError = _c[0], setHasIconError = _c[1];
    var iconUrl = getIconForLanguage(normalizeLanguageCode(code));
    return iconUrl && !hasIconError
        ? (_jsx(Box, { component: "img", src: iconUrl, alt: "", "aria-hidden": "true", onError: function () { return setHasIconError(true); }, sx: { display: 'block', width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 } }))
        : _jsx(FlagIcon, { sx: { fontSize: size - 2, color: 'text.secondary' } });
};
export var LanguageText = function (_a) {
    var code = _a.code, locale = _a.locale;
    return (_jsxs(Box, __assign({ component: 'span', sx: { display: 'inline-flex', alignItems: 'center', gap: '5px' } }, { children: [_jsx(LanguageFlag, { code: code, size: 14 }), getLocalizedLangLabel(normalizeLanguageCode(code), locale) || code] })));
};
export var LanguageChip = function (_a) {
    var code = _a.code, locale = _a.locale, onDelete = _a.onDelete;
    return (_jsx(ElementChip, { text: getLocalizedLangLabel(normalizeLanguageCode(code), locale) || code, onDelete: onDelete, startIcon: _jsx(LanguageFlag, { code: code }) }));
};
